import { isEmpty } from 'lodash';
import type { FC } from 'react';
import React, { memo, useMemo } from 'react';

import { Carousel } from '@sravni/react-design-system';

import Card from '@src/components/ProductList/components/Card';
import type { ListKeys } from '@src/constants/microcredits';
import { useSelectCreditsList } from '@src/reducers/microcredits';

import styles from './styles.module.scss';

interface IProps {
  listKey: ListKeys;
  title?: string;
}

const BestProducts: FC<IProps> = memo((props: IProps) => {
  const { listKey, title } = props;
  const bestProductList = useSelectCreditsList(listKey);

  const content = useMemo(
    () =>
      bestProductList?.items?.slice(0, 4).map((item, index) => (
        <Card
          className={styles.card}
          offer={{
            ...item,
            advertising: item.advertising && {
              ...item.advertising,
              buttonEventAction: 'Платный клик|ТОП4',
            },
          }}
          /**
           * Мы не можем использовать id карточки т.к. они могут повторяться
           * Мы можем использовать индекс т.к. элементы статичны
           */
          // eslint-disable-next-line react/no-array-index-key
          key={`p-item-${index}`}
          position={index}
        />
      )),
    [bestProductList],
  );

  if (isEmpty(bestProductList.items)) {
    return null;
  }

  return (
    <div className={styles.bestProductWrapper}>
      <div className={styles.carousel}>
        <Carousel title={title || 'Лучшие предложения дня'}>{content}</Carousel>
      </div>
    </div>
  );
});

export { BestProducts };
